import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

// Import project components (lazy-loaded for performance)
const ProjectsList = React.lazy(() => import("./ProjectsList"));
const NewProject = React.lazy(() => import("./new"));
const ProjectPage = React.lazy(() => import("./ProjectPage"));
const TimelineView = React.lazy(() => import("./TimelineView"));

const projectsModuleConfig: ModuleConfig = {
    // 🏷️ MODULE IDENTITY
    id: "projects",
    name: "Project Management",
    description: "Track projects, tasks, and deadlines",
    version: "1.0.5",
    enabled: true,
    category: "productivity",
    order: 5,
    icon: "📊",
    color: "#805AD5",

    // 🛣️ ROUTES
    routes: [
        {
            path: "/projects",
            component: ProjectsList,
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            path: "/projects/new",
            component: NewProject,
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            path: "/project/:id",
            component: ProjectPage,
            permissions: ["USER", "ADMIN", "MANAGER"]
        },
        {
            path: "/project/:id/timeline",
            component: TimelineView,
            permissions: ["USER", "ADMIN", "MANAGER"]
        }
    ],

    // 🧭 NAVIGATION
    navigation: [
        {
            label: "All Projects",
            path: "/projects",
            icon: "📋",
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            label: "New Project",
            path: "/projects/new",
            icon: "➕",
            permissions: ["ADMIN", "MANAGER"]
        }
    ],

    // 🔐 PERMISSIONS
    permissions: {
        view: ["USER", "ADMIN", "MANAGER"],
        create: ["ADMIN", "MANAGER"],
        edit: ["ADMIN", "MANAGER"],
        delete: ["ADMIN"]
    },

    // ⚡ QUICK ACTIONS
    quickActions: [
        {
            label: "New Project",
            path: "/projects/new",
            icon: "➕",
            description: "Start a new project"
        }
    ]
};

export default projectsModuleConfig;